import React from "react";
import "./ContactPage.css";
import Navbar from "../Components/Navbar";
import Contact from "../Components/Contact";
import Footer from "../Components/Footer";

const ContactPage = () => {
  document.title = "Contact - Rizatzmi";

  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <section className="Contact-Page">
        <section className="Contact-Section">
          <Contact />
        </section>
      </section>
      <Footer />
    </>
  );
};

export default ContactPage;
